import { configureStore } from "@reduxjs/toolkit";
import configReducer from "../features/admin/store/configSlice";
import webJobsReducer from "../features/admin/store/webjobSlice";
import costSummaryReducer from "../features/cost/store/costSummarySlice";
import costReportReducer from "../features/cost/store/costReportSlice";
import costAnalyticsReducer from "../features/cost/store/costAnalyticsSlice";
import alertReducer from "../features/alerts/store/alertsSlice";
import securityAlertReducer from "../features/security-alerts/store/securityAlertsSlice";
import deploymentReducer from "../features/deployment/store/deploymentSlice";
import alertsTrendReducer from "../features/alerts-trend/store/alertsTrendsSlice";
import alertsSuppressionReducer from "../features/alerts-suppression/store/alertsSuppressionSlice";
import authReducer from "./authSlice";
import { serviceHealthReducer } from "../features/service-health/store/serviceHealthSlice";

export const cncStore = configureStore({
  reducer: {
    auth: authReducer,
    costSummary: costSummaryReducer,
    costReport: costReportReducer,
    costAnalytics: costAnalyticsReducer,
    webJobs: webJobsReducer,
    alerts: alertReducer,
    securityAlerts: securityAlertReducer,
    deployment: deploymentReducer,
    alertsTrend: alertsTrendReducer,
    alertsSuppression: alertsSuppressionReducer,
    serviceHealth: serviceHealthReducer,
    config: configReducer,
  },
});

export type RootState = ReturnType<typeof cncStore.getState>;
export type AppDispatch = typeof cncStore.dispatch;
